import castArray from "lodash/fp/castArray";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import uniq from "lodash/fp/uniq";

const getFieldNames = flow(
  flatMap(castArray),
  flatMap(({ name, options = [] }) => [
    name,
    ...getFieldNames(options.flatMap(getOr([], "fields"))),
  ]),
  uniq
);

export default getFieldNames;
